// import Swiper JS
import Swiper, { Navigation, Pagination, Scrollbar } from 'swiper';
// import Swiper styles
import 'swiper/swiper-bundle.css';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Scrollbar]);

var postSlider = new Swiper('.post-slider', {
  slidesPerView: 1.2,
  spaceBetween: 20,
  scrollbar: {
    el: '.swiper-scrollbar',
    hide: false,
  },
  breakpoints: {
    768: {
      slidesPerView: 1.5,
    },
    1260: {
      slidesPerView: 2,
    }
  }
});